module.exports = __webpack_public_path__ + "media/stylesheets/images/writer2-568c8baa6b10a722d0ce00672b780050.jpg";